import { FC } from 'react';
import styled from 'styled-components';
import { resolveByCountry } from '@codex/helpers';
import uiLocale from '../../translations/UILocale';


const CreditRepresentativeExamplePanelWrapper = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.shades[5]};
  padding: 15px 15px 10px;
  border-radius: 3px;
  margin-bottom: 10px;

  @media ${({ theme }) => theme.breakpoints.mobile} {
    display: none;
  }
`;

const RepresentativeExampleHeader = styled.div`
  font-weight: bold;
  margin-bottom: 10px;
  color: ${({ theme }) => theme.colors.shades[3]};
`;

const RepresentativeExampleMessage = styled.div`
  font-weight: bold;
  margin-bottom: 8px;
  color: ${({ theme }) => theme.colors.shades[3]};
`;

const RepresentativeExampleNote = styled.div`
  font-size: 11px;
  color: ${({ theme }) => theme.colors.shades[3]};
`;

const SeparatorLine = styled.hr`
  display: block;
  height: 1px;
  border: 0;
  border-top: 1px solid ${({ theme }) => theme.colors.shades[5]};
  margin-top: 8px;
  margin-bottom: 6px;
  padding: 0;
`;

const BottomLink = styled.span`
  text-align: center;
  margin-right: 15px;
  margin-bottom: 4px;
  a {
    font-size: 12px;
    color: ${({ theme }) => theme.colors.link.default};
    text-decoration: none;
    :hover {
      ${({ theme }) => theme.colors.link.hover};
    }
  }
`;


const CreditRepresentativeExamplePanel: FC = () => {
  const representativeExampleHeader =
    `*${uiLocale.getString('component.onlinecredit.representative_example_header')}`;

  // the credit representative is general information so it uses the fixed values in the string
  const representativeExampleMessage = uiLocale.getFormattedString(
    'component.onlinecredit.representative_example_message',
    {
      currencySign: resolveByCountry('£', '€'),
      productPrice: 1200.00.toFixed(2),
      numberOfMonthlyPayments: 36,
      monthPricePayment: 46.10.toFixed(2),
      totalAmountPayable: 1659.60.toFixed(2),
      APR: 24.9
    }
  );

  const representativeExampleNote = uiLocale.getString('component.onlinecredit.representative_example_note');
  const creditAccountFaqsLink = uiLocale.getString('component.onlinecredit.credit_account_faq_link');
  const creditAccountInformationLink = uiLocale.getString('component.onlinecredit.credit_account_information_link');

  return (
    <CreditRepresentativeExamplePanelWrapper>
      <RepresentativeExampleHeader>{representativeExampleHeader}</RepresentativeExampleHeader>
      <RepresentativeExampleMessage>{representativeExampleMessage}</RepresentativeExampleMessage>
      <RepresentativeExampleNote>{representativeExampleNote}</RepresentativeExampleNote>
      <SeparatorLine />
      <div>
        <BottomLink
          dangerouslySetInnerHTML={{ __html: creditAccountFaqsLink }}
        />
        <BottomLink
          dangerouslySetInnerHTML={{ __html: creditAccountInformationLink }}
        />
      </div>
    </CreditRepresentativeExamplePanelWrapper>
  );
};

CreditRepresentativeExamplePanel.displayName = 'CreditRepresentativeExamplePanel';
export default CreditRepresentativeExamplePanel;
